import LocalStorageUtils from './util';
import { DriveItemListDisplayType } from '../../containers/DriveItemList/constants';
import { LocalStorageDownloadInfos } from '../../containers/DownloadManager/actions';
import { GalleryInfosState } from '../../containers/Gallery/reducer';
import { DriveListState } from '../../containers/DriveItemList/reducer';
import { OfflineManagerState } from '../../containers/OfflineManager/reducer';
import { AuthenticationUserState } from '../../containers/Authentication/reducer';
import { MultiAppAuthenticationCredentials } from '../../containers/MultiAppAuthentication/reducer';
import { Server } from '../../containers/MultiAppAuthentication/constants';
import { Api } from '../../typings/api';

export default class LocalStorageManager extends LocalStorageUtils {
	private static displayTypeKey = 'gallApp-driveItemListDisplayType';
	private static downloadPopupDontAskAgainKey = 'gallApp-downloadPopupDontAskAgain';
	private static favoritesKey = 'gallApp-favorites';
	private static downloadsKey = 'gallApp-downloads';
	private static lastVisitDateKey = 'gallApp-lastVisitDate';
	private static storeGalleryConfigKey = 'gallApp-galleryConfig';
	private static storeGalleryInfosKey = 'gallApp-galleryInfos';
	private static storeDriveListKey = 'gallApp-driveList';
	private static storeOfflineManagerKey = 'gallApp-offlineManager';
	private static storeUserInfosKey = 'gallApp-userInfos';
	private static multiAppCredentialsKey = 'gallApp-multiAppCredentials';
	private static multiAppServerKey = 'gallApp-multiAppServer';

	// DisplayType
	public static setDisplayType(displayType: DriveItemListDisplayType): void {
		LocalStorageManager.setItem(LocalStorageManager.displayTypeKey, displayType, false);
	}

	public static getDisplayType(): DriveItemListDisplayType | null {
		return LocalStorageManager.getItem<DriveItemListDisplayType>(LocalStorageManager.displayTypeKey, false);
	}

	// DownloadPopupDontAskAgain
	public static setDownloadPopupDontAskAgain(): void {
		LocalStorageManager.setItem(LocalStorageManager.downloadPopupDontAskAgainKey, true, true);
	}

	public static getDownloadPopupDontAskAgain(): true | null {
		return LocalStorageManager.getItem<true>(LocalStorageManager.downloadPopupDontAskAgainKey, true);
	}

	// Favorites
	public static setFavorites(favorites: number[]): void {
		LocalStorageManager.setItem(LocalStorageManager.favoritesKey, favorites, true);
	}

	public static getFavorites(): number[] | null {
		return LocalStorageManager.getItem<number[]>(LocalStorageManager.favoritesKey, true);
	}

	// Downloads
	public static setDownloads(downloads: LocalStorageDownloadInfos[]) {
		LocalStorageManager.setItem(LocalStorageManager.downloadsKey, downloads, true);
	}

	public static getDownloads(): LocalStorageDownloadInfos[] | null {
		return LocalStorageManager.getItem<LocalStorageDownloadInfos[]>(LocalStorageManager.downloadsKey, true);
	}

	public static removeDownloads(): void {
		LocalStorageManager.removeItem(LocalStorageManager.downloadsKey, true);
	}

	// LastVisitDate
	public static setLastVisitDate(date: Date): void {
		LocalStorageManager.setItem(LocalStorageManager.lastVisitDateKey, date, true);
	}

	public static getLastVisitDate(): Date | null {
		const lastVisitDate = LocalStorageManager.getItem<string>(LocalStorageManager.lastVisitDateKey, true);
		if (!lastVisitDate) {
			return null;
		}
		return new Date(lastVisitDate);
	}

	// GalleryConfig
	public static setStoreGalleryConfig(storeGalleryConfig: Api.Config): void {
		LocalStorageManager.setItem(LocalStorageManager.storeGalleryConfigKey, storeGalleryConfig, false);
	}

	public static getStoreGalleryConfig(): Api.Config | null {
		return LocalStorageManager.getItem<Api.Config>(LocalStorageManager.storeGalleryConfigKey, false);
	}

	public static removeStoreGalleryConfig(): void {
		LocalStorageManager.removeItem(LocalStorageManager.storeGalleryConfigKey, false);
	}

	// GalleryInfos
	public static setStoreGalleryInfos(storeGalleryInfos: GalleryInfosState): void {
		LocalStorageManager.setItem(LocalStorageManager.storeGalleryInfosKey, storeGalleryInfos, true);
	}

	public static getStoreGalleryInfos(): GalleryInfosState | null {
		return LocalStorageManager.getItem<GalleryInfosState>(LocalStorageManager.storeGalleryInfosKey, true);
	}

	// DriveList
	public static setStoreDriveList(driveList: DriveListState): void {
		LocalStorageManager.setItem(LocalStorageManager.storeDriveListKey, driveList, true);
	}

	public static getStoreDriveList(): DriveListState | null {
		return LocalStorageManager.getItem<DriveListState>(LocalStorageManager.storeDriveListKey, true);
	}

	// OfflineManager
	public static setStoreOfflineManager(offlineManager: OfflineManagerState): void {
		LocalStorageManager.setItem(LocalStorageManager.storeOfflineManagerKey, offlineManager, true);
	}

	public static getStoreOfflineManager(): OfflineManagerState | null {
		return LocalStorageManager.getItem<OfflineManagerState>(LocalStorageManager.storeOfflineManagerKey, true);
	}

	// Credentials
	public static setCredentials(credentials: AuthenticationUserState): void {
		LocalStorageManager.setItem(LocalStorageManager.storeUserInfosKey, credentials, true);
	}

	public static getCredentials(): AuthenticationUserState | null {
		return LocalStorageManager.getItem<AuthenticationUserState>(LocalStorageManager.storeUserInfosKey, true);
	}

	public static removeCredentials(): void {
		LocalStorageManager.removeItem(LocalStorageManager.storeUserInfosKey, true);
	}

	// MultiAppCredentials
	public static setMultiAppCredentials(credentials: MultiAppAuthenticationCredentials): void {
		LocalStorageManager.setItem(LocalStorageManager.multiAppCredentialsKey, credentials, false);
	}

	public static getMultiAppCredentials(): MultiAppAuthenticationCredentials | null {
		return LocalStorageManager.getItem<MultiAppAuthenticationCredentials>(LocalStorageManager.multiAppCredentialsKey, false);
	}

	public static removeMultiAppCredentials(): void {
		LocalStorageManager.removeItem(LocalStorageManager.multiAppCredentialsKey, false);
	}

	// MultiAppServer
	public static setMultiAppServer(server: Server): void {
		LocalStorageManager.setItem(LocalStorageManager.multiAppServerKey, server, false);
	}

	public static getMultiAppServer(): Server | null {
		return LocalStorageManager.getItem<Server>(LocalStorageManager.multiAppServerKey, false);
	}

	public static removeMultiAppServer(): void {
		LocalStorageManager.removeItem(LocalStorageManager.multiAppServerKey, false);
	}
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/localStorage/manager.ts